/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import HospitalsidHospital from './HospitalsidHospital';

/**
 * The ServiceLinesIdBody model module.
 * @module model/ServiceLinesIdBody
 * @version v0.3
 */
export default class ServiceLinesIdBody {
  /**
   * Constructs a new <code>ServiceLinesIdBody</code>.
   * @alias module:model/ServiceLinesIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceLinesIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceLinesIdBody} obj Optional instance to populate.
   * @return {module:model/ServiceLinesIdBody} The populated <code>ServiceLinesIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceLinesIdBody();
      if (data.hasOwnProperty('service_line'))
        obj.serviceLine = HospitalsidHospital.constructFromObject(data['service_line']);
    }
    return obj;
  }
}

/**
 * @member {module:model/HospitalsidHospital} serviceLine
 */
ServiceLinesIdBody.prototype.serviceLine = undefined;

